import { render } from "./VisitorPrinterSetup.vue?vue&type=template&id=56f2cf91"
import script from "./VisitorPrinterSetup.vue?vue&type=script&lang=js"
export * from "./VisitorPrinterSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__